import Resource from '../../api/resource'
import request from '../../utils/request';

class Case extends Resource {
    constructor() {
        super('cases');
    }


    changeStatus(payload) {
        return request({
            url: `/cases/${payload.id}`,
            method: 'post',
            data: payload.query,
        });
    }


    export(payload, onDownloadProgress) {
        return request({
            url: `/cases/export`,
            method: 'post',
            responseType: "blob",
            data: { ...payload },
            onDownloadProgress
        });
    }

    // MRM Export
    exportMrm(payload, onDownloadProgress, cancelToken) {

        return request({
            url: `/cases/exportMrm`,
            method: 'post',
            responseType: "blob",
            data: { ...payload },
            onDownloadProgress,
            cancelToken
        });
    }

    // Approval Tracking Export
    exportApprovalTracking(payload, onDownloadProgress, cancelToken) {
        return request({
            url: `/cases/export_approval_tracking`,
            method: 'post',
            responseType: "blob",
            data: { ...payload },
            onDownloadProgress,
            cancelToken
        });
    }

    // Invoice Report Export
    exportInvoiceReport(payload, onDownloadProgress, cancelToken) {
        return request({
            url: `/cases/export_invoice_report`,
            method: 'post',
            responseType: "blob",
            data: { ...payload },
            onDownloadProgress,
            cancelToken
        });
    }

    exportCollectedReport(payload, onDownloadProgress, cancelToken) {
        return request({
            url: `/cases/export_collected-report`,
            method: 'post',
            responseType: "blob",
            data: { ...payload },
            onDownloadProgress,
            cancelToken
        });
    }
    exportTrendingReport(payload, onDownloadProgress, cancelToken) {
        return request({
            url: `/cases/export_trending-report`,
            method: 'post',
            responseType: "blob",
            data: { ...payload },
            onDownloadProgress,
            cancelToken
        });
    }

    // Discharge Summary Report Export
    exportDischargeSummary(payload, onDownloadProgress, cancelToken) {
        return request({
            url: `/cases/export_discharge-summary`,
            method: 'post',
            responseType: "blob",
            data: { ...payload },
            onDownloadProgress,
            cancelToken
        });
    }

    // EMR Report Export
    exportEmrReport(payload, onDownloadProgress, cancelToken) {
        return request({
            url: `/cases/export_emr-report`,
            method: 'post',
            responseType: "blob",
            data: { ...payload },
            onDownloadProgress,
            cancelToken
        });
    }
    assignAuditor(payload) {
        return request({
            url: `/cases/assign-auditor`,
            method: 'post',
            data: payload,
        });
    }

}

export { Case as default };
